<template lang="html">
    <v-container fluid class="pa-0">

        <v-card>
            <v-data-table
                    :headers="headers"
                    :items="poslogs"
                    :loading="loading"
                    :options.sync="options"
                    :server-items-length="nbMaxPoslogs"
                    loading-text="Your request is being processed, please wait ..."
                    no-data-text="Select a business unit, a period, some filters or input what you’re looking for in the search bar to get some matching results displayed."
                    no-results-text="No results found"
                    :footer-props="{'items-per-page-options' : [5, 10, 15]}"
            >
                <template v-slot:item.createdAt="{ item }">
                    {{item.createdAt | formatDate}}
                </template>
                <template v-slot:item.transactionDateTime="{ item }">
                    {{item.transactionDateTime | formatDate}}
                </template>
                <template v-slot:item.poslog="{ item }">
                    <v-icon @click="openTransactionView(item)">code</v-icon>
                </template>
                <template v-slot:item.receipt="{ item }">
                    <v-icon v-if="item.trailerText" @click="openReceiptView(item)">
                        receipt
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
        <code-dialog v-model="dialog.show" :title="dialog.title" :code="dialog.code"
                     :lang="dialog.lang"></code-dialog>

    </v-container>
</template>

<script>
    import {SEARCH_NS} from '@/store/modules/search/constants'
    import {mapActions, mapGetters} from "vuex";
    import CodeDialog from "@/components/shared/CodeDialog";

    export default {
        components: {CodeDialog},
        data: () => ({
            headers: [
                {text: 'UploadDateTime', value: 'createdAt'},
                {text: 'Country', value: 'country', sortable: false},
                {text: 'BusinessUnit', value: 'bu', sortable: false},
                {text: 'TransactionDateTime', value: 'transactionDateTime'},
                {text: 'WorkstationID', value: 'workstationID', sortable: false},
                {text: 'SequenceNumber', value: 'sequenceNumber'},
                {text: 'PosLog', value: 'poslog', sortable: false},
                {text: 'Receipt', value: 'receipt', sortable: false},
            ],
            dialog: {
                show: false,
                title: '',
                lang: 'plaintext',
                code: ''
            },
        }),
        computed: {
            ...mapGetters(SEARCH_NS, [
                'poslogs',
                'nbMaxPoslogs',
                'loading'
            ]),
            options: {
                get() {
                    return this.$store.getters[`${SEARCH_NS}/poslogsTableOptions`];
                },
                set(val) {
                    this.$store.dispatch(`${SEARCH_NS}/updatePoslogsTableOptions`, val);
                }
            }
        },
        methods: {
            ...mapActions(SEARCH_NS, [
                'updatePoslogsTableOptions'
            ]),
            openReceiptView(item) {
                this.dialog = {
                    show: true,
                    lang: 'plaintext',
                    title: item.transactionID,
                    code: item.trailerText
                };
            },
            openTransactionView(item) {
                window.open(`${window.origin}/transaction/${item.transactionID}`, '_blank');
            }
        }
    }
</script>
